
const QRCodeWrapper = ({ value, size = 200 }) => {
  if (!value) {
    return (
      <div className="w-48 h-48 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto mb-2"></div>
          <p className="text-sm text-gray-500">
            Generando QR...
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex justify-center">
      <div className="bg-white p-4 rounded-lg border shadow-sm">
        <img 
          src={value}
          alt="QR Code"
          style={{
            maxWidth: '100%',
            height: 'auto',
            width: size
          }}
        />
      </div>
    </div>
  )
}

export default QRCodeWrapper